<template>
  <div>

      <!-- Header -->
      <div class="py-3 mb-3 border-bottom">
          <div class="container">
              <div class="d-flex">
                  <h5 class="m-0 p-0 align-self-center">
                      <i class="fas fa-tv mr-1"></i> Cursos
                  </h5>
              </div>
          </div>
      </div>

      <!-- Container -->
      <div class="container mx-auto">
          <b-overlay :show="loading" rounded="sm">
            <div class="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-2 row-cols-xl-3 row-cols-xxl-4">

                    <div class="col mb-3" style="max-width: 310px;"  v-for="course in courses" :key="course.id">
                        <!--

                            <div class="card mb-3 border shadow" >
                                <div class="card-header py-3">
                                    <a :href="'/student/courses/' + course.id + '/modules'">
                                        <h5 class="card-title p-0 m-0">
                                            {{ course.name }}
                                        </h5>
                                    </a>
                                </div>
                                <div class="card-img border-bottom">
                                    <img :src="course.img_preview_url" alt="" style="width: 100%; height: 250px" />
                                </div>
                                <div class="card-body">
                                    <div class="text-sm">
                                        {{ course.percentage_completed }}% concluído
                                    </div>
                                    <b-progress
                                        :value="course.percentage_completed"
                                        :max="100"
                                        variant="success"
                                        height="10px"></b-progress>
                                </div>
                            </div>
                        -->

                        <div class="course-card shadow-sm rounded-lg" role="button" >
                            <div class="course-title p-2 text-white d-flex gap-2 justify-content-between " @click="openModule(course)">
                                <p class="w-fit font-weight-bolder h4 mt-auto mb-0"><span class="shadow-sm">{{course.name}}</span></p>


                            </div>

                            <img :src="course.img_preview_url" class="course-image" alt=""/>

                            <div class="course-info p-2 w-100 d-flex justify-content-between align-items-center gap-2">
                                <div class="badge badge-dark p-1">
                                    <span class="">{{course.modules.length}}</span> Módulos
                                </div>
                                <div class="badge badge-success p-1" v-if="parseInt(course.percentage_completed) === 100">
                                    {{ course.percentage_completed }}%
                                </div>
                                <div class="badge badge-dark p-1" v-else>
                                    {{ course.percentage_completed }}%
                                </div>


                            </div>
                        </div>
                    </div>
            </div>

              <div v-if="courses.length === 0" class="text-center py-5 my-4">
                  Não há cursos disponíveis para você assistir no momento.
              </div>
          </b-overlay>
      </div>
  </div>
</template>

<script>

export default {
    data() {
        return {
            loading: false,
            courses: [],
        }
    },
    created() {
        this.load();
    },
    methods: {
        load() {
            this.loading = true;
            axios.get('/student/courses/all')
                .then(response => {
                    this.courses = response.data.data.courses;
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                });
        },

        openModule(course){
            window.location.href = '/student/courses/' + course.id + '/modules'
        }
    },
}
</script>

<style scoped>
.course-card{
    max-width: 310px;
    height: 430px;
    overflow: hidden;
    position: relative;

}



.course-image{
    position: absolute;
    width: auto;
    height: 100%;
    left: 50%;
    transform: translateX(-50%);

}
.course-title {
    position: absolute;
    z-index: 998;
    width: 100%;
    height: 100%;
    transition: 2s ease-in-out;
    cursor: pointer;
    background: linear-gradient(0deg, rgba(0,0,0,.8) 0%, rgba(249,249,249,0) 80%);

}
.course-title:hover {
    background: linear-gradient(0deg, rgba(0,0,0,.8) 0%, rgba(0,0,0,0.5) 80%);
    transition: 2s ease-in-out;

}

.course-info {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
}
</style>
